// Keyword pools used across pages for meta tags, JSON-LD, and ALT text
// Curated for Google to associate this site with "Pacific church uniforms NZ"
// search intent and rank for high-buyer-intent queries.

export const CORE_KEYWORDS = [
  "Samoan Church Uniforms",
  "Tongan Church Uniforms",
  "Cook Islands Church Uniforms",
  "Pacific Church Uniforms",
  "Pacific Heritage Uniforms",
  "Church Choir Uniforms",
  "Custom Choir Uniforms",
  "Church Polo Shirts",
  "Custom Church Polo Shirts",
  "Samoan Polo Shirts",
  "Tongan Polo Shirts",
  "Cook Islands Polo Shirts",
  "Custom Pacific Polo Shirts",
  "Pasifika Church Uniforms",
  "Polynesian Church Uniforms",
  "Church Conference Polo Shirts",
  "Family Reunion Polo Shirts",
  "Village Reunion Uniforms",
  "Pacific Ministry Uniforms",
  "Custom Pasifika Uniforms",
  "Auckland Pacific Uniforms",
  "Pacific Community Uniforms NZ",
  "Bulk Pacific Polo Shirts",
  "Church Uniforms Auckland",
  "Church Uniforms NZ",
  "EFKS Church Uniforms",
  "CCCS Church Uniforms",
  "AOG Church Uniforms",
  "Tongan Methodist Uniforms",
  "CICC Church Uniforms",
  "Samoan Church Choir Uniforms",
  "Tongan Church Choir Polo",
  "Cook Islands Tivaevae Polo",
  "Pacific Youth Ministry Uniforms",
  "Pacific Women's Fellowship Polo",
];

export const SAMOAN_KEYWORDS = [
  "Samoan Church Uniforms",
  "Samoan Polo Shirts",
  "EFKS Uniforms",
  "CCCS Church Uniforms",
  "Samoan Church Choir Uniforms",
  "Samoan Family Reunion Polo Shirts",
  "Samoan Aiga Reunion Polo",
  "Samoan AOG Uniforms",
  "Pacific Heritage Uniforms NZ",
  "Custom Samoan Uniforms Auckland",
  "Siapo Pattern Polo Shirts",
];

export const TONGAN_KEYWORDS = [
  "Tongan Church Uniforms",
  "Tongan Polo Shirts",
  "Siasi Uesiliana Uniforms",
  "Tongan Free Wesleyan Uniforms",
  "Tongan Methodist Uniforms",
  "Tongan Catholic Church Polo",
  "Tongan Church Choir Polo",
  "Tongan Family Reunion Polo Shirts",
  "Ngatu Pattern Polo Shirts",
  "Custom Tongan Uniforms Auckland",
];

export const COOK_ISLANDS_KEYWORDS = [
  "Cook Islands Church Uniforms",
  "Cook Islands Polo Shirts",
  "CICC Uniforms",
  "CIPC Uniforms",
  "Tivaevae Pattern Polo Shirts",
  "Cook Islands Family Reunion Polo",
  "Cook Islands Maeva Nui Uniforms",
  "Rarotonga Polo Shirts",
  "Custom Cook Islands Uniforms NZ",
];

export const CONFERENCE_KEYWORDS = [
  "Church Conference Uniforms",
  "Pacific Conference Polo Shirts",
  "Conference Volunteer Polo Shirts",
  "Conference Host Uniforms",
  "Church Camp Polo Shirts",
  "Pacific Youth Conference Uniforms",
  "Bulk Conference Polo Shirts NZ",
  "Christian Conference Uniforms NZ",
];

export const REUNION_KEYWORDS = [
  "Reunion Polo Shirts",
  "Family Reunion Polo Shirts",
  "Village Reunion Uniforms",
  "Aiga Reunion Polo",
  "Kainga Reunion Polo",
  "Kopu Tangata Polo Shirts",
  "Pacific Family Reunion Uniforms NZ",
  "Samoan Reunion Polo Shirts",
  "Tongan Reunion Polo Shirts",
  "Cook Islands Reunion Polo Shirts",
];

export const AUCKLAND_KEYWORDS = [
  "Church Uniforms Auckland",
  "Pacific Uniforms Auckland",
  "Custom Polo Shirts Auckland",
  "Samoan Church Uniforms Auckland",
  "Tongan Church Uniforms Auckland",
  "Cook Islands Uniforms Auckland",
  "South Auckland Church Uniforms",
  "West Auckland Pacific Uniforms",
  "Manukau Church Polo Shirts",
  "Otahuhu Church Uniforms",
  "Mangere Pacific Polo Shirts",
];

export function joinKw(list) {
  return list.join(", ");
}
